import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from "../../../Context/ThemeContext.js";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants.js";
import "./trustsafety.css";

const ImprintsPage = () => {
  const { t } = useTranslation();
  const { mode } = useThemeContext();

  const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
  const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
  const spancolor = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
  const linkcolor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box className="faq-sec">
      {/* Header */}
      <Typography className='trust-title' variant="h4" gutterBottom style={{ color: headingcolor }}>
        {t('imprints.imprintTitle')}
      </Typography>

      {/* Company Name */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.companyNameTitle')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.companyName')}
        </Typography>
      </Box>

      {/* Registered Address */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.registeredAddressTitle')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.registeredAddressLine1')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.registeredAddressLine2')}
        </Typography>
      </Box>

      {/* Represented by */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.representedByTitle')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          <span className='terms-span' style={{ color: spancolor }}>{t('imprints.managingDirector')}</span>
          {t('imprints.managingDirectorText')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          <span className='terms-span' style={{ color: spancolor }}>{t('imprints.ceo')}</span>
          {t('imprints.ceoText')}
        </Typography>
      </Box>

      {/* Contact */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.contactTitle')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          <span className='terms-span' style={{ color: spancolor }}>{t('imprints.emailLabel')}</span>
          {t('imprints.emailAddress')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          <span className='terms-span' style={{ color: spancolor }}>{t('imprints.phoneLabel')}</span>
          {t('imprints.phoneNumber')}
        </Typography>
      </Box>

      {/* Commercial Register Entry */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.commercialRegisterTitle')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.registeredAtCourt')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.registrationNumberLabel')}: {t('imprints.registrationNumber')}
        </Typography>
      </Box>

      {/* VAT Identification Number */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.vatIdTitle')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.vatIdNumber')}
        </Typography>
      </Box>

      {/* Responsible for Website Content */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.responsibleForContentTitle')}
        </Typography>
        <Typography className='terms-li' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.responsiblePersonName')}
        </Typography>
      </Box>

      {/* Dispute Resolution */}
      <Box className='security-sec imprint_gap' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.disputeResolutionTitle')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" sx={{  color: subtitletext }}>
          {t('imprints.disputeResolutionText1')}
          <a href={t('imprints.odrLink')} target="_blank" rel="noopener noreferrer" style={{ color: linkcolor, textDecoration: 'underline', cursor: 'pointer' ,wordBreak: 'break-word' }}>
            {t('imprints.odrLink')}
          </a>
        </Typography>
        <Typography className='trust-sub-title' variant="body1" sx={{ color: subtitletext }}>
          {t('imprints.disputeResolutionText2')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" sx={{ color: subtitletext }}>
          {t('imprints.disputeResolutionText3')}
        </Typography>
      </Box>

      {/* Liability for Content */}
      <Box className='security-sec imprint_gap' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.liabilityContentTitle')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.liabilityContentText')}
        </Typography>
        <Typography  className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.liabilityContentText1')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.liabilityContentText2')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.liabilityContentText3')}
        </Typography>
      </Box>

      {/* Liability for Links */}
      <Box className='terms-sec imprint_gap' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.liabilityLinksTitle')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.liabilityLinksText')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.liabilityLinksText1')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.liabilityLinksText2')}
        </Typography>
      </Box>

      {/* Copyright */}
      <Box className='terms-sec imprint_gap' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.copyrightTitle')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.copyrightText')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.copyrightText1')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.copyrightText2')}
        </Typography>
      </Box>

      {/* Image and Media Credits */}
      <Box className='attr-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.imageCreditsTitle')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.imageCreditsText')}
        </Typography>
        <ul className='terms-ol login-term'>
          <li className='terms-li' style={{ color: subtitletext }}>
            <a href={"https://unsplash.com/"} target="_blank" rel="noopener noreferrer" style={{ color: linkcolor, textDecoration: 'underline', cursor: 'pointer' }}>
              {t('imprints.unsplash')}
            </a>
          </li>
          <li className='terms-li' style={{ color: subtitletext }}>
            <a href={"https://pexels.com/"} target="_blank" rel="noopener noreferrer" style={{ color: linkcolor, textDecoration: 'underline', cursor: 'pointer' }}>
              {t('imprints.pexels')}
            </a>
          </li>
          <li className='terms-li' style={{ color: subtitletext }}>
            <a href={"https://www.magnific.com/"} target="_blank" rel="noopener noreferrer" style={{ color: linkcolor, textDecoration: 'underline', cursor: 'pointer' }}>
              {t('imprints.freepik')}
            </a>
          </li>
          <li className='terms-li' style={{ color: subtitletext }}>
            <a href={"https://thenounproject.com/"} target="_blank" rel="noopener noreferrer" style={{ color: linkcolor, textDecoration: 'underline', cursor: 'pointer' }}>
              {t('imprints.nounProject')}
            </a>
          </li>
        </ul>
      </Box>

      {/* Design and Implementation */}
      <Box className='terms-sec' my={5}>
        <Typography className='trust-terms' variant="h6" gutterBottom style={{ color: headingcolor }}>
          {t('imprints.designImplementationTitle')}
        </Typography>
        <Typography className='trust-sub-title' variant="body1" style={{ color: subtitletext }}>
          {t('imprints.designImplementationText')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ImprintsPage;